<template>
  <div class="platforms-container">
    <h1 class="title">{{ $t("platforms.title") }}</h1>
    <p class="serve-name" v-if="region === 'mena'">
      <span>
        <strong>{{ $t("platforms.accountLive") }}</strong> 
        : {{ $t("platforms.tradeviewLive") }}
      </span>
      <br />
      <span><strong>{{ $t("platforms.accountDemo") }}</strong>
        : {{ $t("platforms.tradeviewDemo") }}
      </span>
    </p>
    <p class="serve-name" v-if="region !== 'mena'">
      <span>
        <strong>{{ $t("platforms.accountLive") }}:</strong> 
        {{ $t("platforms.tradeviewLive") }}
      </span>
      <br />
      <span><strong>{{ $t("platforms.accountDemo") }}:</strong>
        {{ $t("platforms.tradeviewDemo") }}
      </span>
    </p>
    <section class="content-platforms">
      <!-- Links MT4 -->
      <div class="content-card">
        <h2 class="title-plt"><img :src="optionsThemeMT4" />MetaTrader 4</h2>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/web/tradeview.ltd/mt4/tradeview4setup.exe"
          target="_blank"
        >
          <h4><img src="/assets/images/icon_windows.svg" alt="" /> Windows</h4>
        </a>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/MetaTrader4.dmg?utm_source=www.metatrader4.com&utm_campaign=download.mt4.macos"
          target="_blank"
        >
          <h4><img src="/assets/images/icon_mac.svg" alt="" /> MAC</h4>
        </a>
        <a
          class="card-link"
          href="https://mt5wb.tradeviewforex.com/"
          target="_blank"
        >
          <h4>
            <img src="/assets/images/icon_webtrader.svg" alt="" /> Web Trader
          </h4>
        </a>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/mobile/mt4/android?server=TradeviewEurope-Demo%20Europe,TradeviewEurope-Live%20Europe"
          target="_blank"
        >
          <h4>
            <img src="/assets/images/icon_googleplay.svg" alt="" /> Google Play
          </h4>
        </a>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/mobile/mt4/ios?server=TradeviewEurope-Demo%20Europe,TradeviewEurope-Live%20Europe"
          target="_blank"
        >
          <h4>
            <img src="/assets/images/icon_appstore.svg" alt="" /> App Store
          </h4>
        </a>
      </div>

      <!-- Links MT5 -->
      <div class="content-card">
        <h2 class="title-plt"><img :src="optionsThemeMT5" /> MetaTrader 5</h2>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/web/tradeview.ltd/mt5/tradeview5setup.exe"
          target="_blank"
        >
          <h4><img src="/assets/images/icon_windows.svg" alt="" /> Windows</h4>
        </a>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/MetaTrader5.dmg?utm_source=www.metatrader5.com&utm_campaign=download"
          target="_blank"
        >
          <h4><img src="/assets/images/icon_mac.svg" alt="" /> MAC</h4>
        </a>
        <a
          class="card-link"
          href="https://mt5wb.tradeviewforex.com/"
          target="_blank"
        >
          <h4>
            <img src="/assets/images/icon_webtrader.svg" alt="" /> Web Trader
          </h4>
        </a>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/mobile/mt5/android?server=TradeviewEurope-Demo"
          target="_blank"
        >
          <h4>
            <img src="/assets/images/icon_googleplay.svg" alt="" /> Google Play
          </h4>
        </a>
        <a
          class="card-link"
          href="https://download.mql5.com/cdn/mobile/mt5/ios?server=TradeviewEurope-Demo"
          target="_blank"
        >
          <h4>
            <img src="/assets/images/icon_appstore.svg" alt="" /> App Store
          </h4>
        </a>
      </div>
    </section>
  </div>
</template>



<script>
import { onMounted, ref } from "@vue/runtime-core";
import { getCurrentInstance } from "@vue/runtime-core";
import store from "@/store";

export default {
  name: "Platforms",
  setup() {
    let optionsThemeMT4 = ref("/assets/images/icon_metatrader_4_black.svg");
    let optionsThemeMT5 = ref("/assets/images/icon_metatrader_5_black.svg");
    let region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    const internalInstance = getCurrentInstance(); //vue3 global function
    const emitter = internalInstance.appContext.config.globalProperties.emitter; // update this function at the global cabinet level

    onMounted(() => {
      emitter.on("preferencesUpdated", () => {
        imgSite();
      });
    });

    const imgSite = () => {
      if (store.state.preferences) {
        let theme = store.state.preferences.theme;
        switch (theme) {
          case "DARK":
            optionsThemeMT4.value =
              "/assets/images/icon_metatrader_4_white.svg";
            optionsThemeMT5.value =
              "/assets/images/icon_metatrader_5_white.svg";
            break;
          case "LIGHT":
            optionsThemeMT4.value =
              "/assets/images/icon_metatrader_4_black.svg";
            optionsThemeMT5.value =
              "/assets/images/icon_metatrader_5_black.svg";
            break;
        }
      }
    };

    imgSite();

    return {
      optionsThemeMT4,
      optionsThemeMT5,
      imgSite,
      region,
    };
  },
};
</script>



